var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkoutActionView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M505.77,392.81c-52.9,0-95.71,47.54-95.71,106.22s42.81,106.82,95.71,106.82,95.05-48.15,95.05-106.82-42.18-106.22-95.05-106.22h0ZM508.12,172.4c-262.09,0-474.84,198.05-474.84,340.19s212.74,339,474.84,339,476.03-201.35,476.03-339-212.78-340.19-476.03-340.19h0ZM506.33,732.41c-111.13,0-200.87-101.23-200.87-225.36s89.74-225.98,200.87-225.98,202.07,100.65,202.07,225.98-90.34,225.36-202.07,225.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutActionView);
export default __webpack_public_path__ + "static/media/workout-action-view.3d626e9d859558c430971efe7604c2a2.svg";
export { ForwardRef as ReactComponent };